export const DEFAULT_CURRENCY_PRECISION = 2;
